//privacy-policy page
(function() {
    var $page = $('.page-privacy');
    if (!$page.length) return false;
    var $nav = $page.find('.page-nav');
    var offset = $nav.offset().top;
    var scroll = function() {
        var y = $(window).scrollTop();
        if (y>=offset) {
            $nav.addClass('nav--fixed');
        } else {
            $nav.removeClass('nav--fixed');
        }
    };
    scroll();
    $(window).on('scroll', function() {
        scroll();
    });
    $nav.find('li a').on('click', function() {
        var target = $(this).attr('href');
        var $target = $(target);
        if ($target.length) {
            var pos = $target.offset().top - 20;
            $('html, body').stop().animate({
                scrollTop: pos
            }, 600);
        }
        return false;
    });
})();